app.service('EventService', ['$http', function($http) {
  this.getEvents = function() {
    return $http.get('/api/event/get');
  }
}]);
